/**
 * 
 * Chỉ các file trong stores/Actios giao tiếp trực tiếp với tầng "Manager" của giao diện
*/

import { RootState } from '@/stores/dataStore/reduxStore/store'
import { IInstrumentsDynamic, IInstrumentsStatic, ISymbolsGroup } from '@/stores/dataStore/reduxStore/symbol/interfaceSymbol'
import { getInstrumentsByExchange, getInstrumentsBySymbols, getSymbolsList } from "@/stores/dataStore/reduxStore/symbol/symbolsSlice"
// import CommonUtils from '@/utilities/utils'
import findIndex from 'lodash/findIndex'
import { store } from "../../dataStore/reduxStore/store"
import { LIST_TAB_PB_ID } from "@/stores/dataStore/memoryStore/const/constIndex"
import { mergeArrayByOnlyKeyArr1 } from '@npm_dev/fss-utilities'
const dispatch = store.dispatch


/**
 * 
 * GET data
 */
export const SSymbolsList = (state: RootState) => state.symbol.symbolsList
export const SSymbolsGroup = (state: RootState) => state.symbol.symbolsGroup
export const SSymbolsGroupStatus = (state: RootState) => state.symbol.symbolsGroupStatus
export const SInstrumentsStatic = (state: RootState) => state.symbol.instrumentsStatic
export const SInstrumentsStaticStatus = (state: RootState) => state.symbol.instrumentsStaticStatus
export const SInstrumentsDynamic = (state: RootState) => state.symbol.instrumentsDynamic

//=====================================================================================================
/**
 * 
 * GET function
 */
export const getSymbolsListAction = () => {
    return dispatch(getSymbolsList())
}
/**
 * 
 * @returns 
 */
export const getInstrumentsAction = (params: { config?: object, idPbTab: string }) => {
    try {
        let _params: object = {}
        let _exchange = undefined
        let idPbTab = params?.idPbTab
        switch (idPbTab) {
            case LIST_TAB_PB_ID['HOSE']['id']:
            case LIST_TAB_PB_ID['HNX']['id']:
            case LIST_TAB_PB_ID['UPCOM']['id']:
                _exchange = LIST_TAB_PB_ID[idPbTab]['exchange']
                _params = {
                    config: {
                        ...params?.config
                    },
                    exchange: _exchange,
                }
                dispatch(getInstrumentsByExchange(_params))
                break;
            default:
                _exchange = LIST_TAB_PB_ID[idPbTab]['exchange']
                _params = {
                    config: params?.config,
                    exchange: _exchange
                }
                dispatch(getInstrumentsByExchange(_params))
                break;
        }

        return () => { }
    }
    catch (e) {
        return () => { }
    }
}
/**
 * 
 */
export const getSymbolsByIdPbTabAction = (params: { idPbTab: string }) => {
    let resDefault = {
        list: [],
        data: [] as string[]
    }
    try {
        const state = store.getState()
        let { symbolsGroup } = state.symbol as { symbolsGroup: ISymbolsGroup[] }
        let index = findIndex(symbolsGroup, e => e.ID === params?.idPbTab)
        if (index == -1) {
            return resDefault
        }
        let list = symbolsGroup[index]?.SYMBOLS || []
        let data = symbolsGroup[index]?.SYMBOLS_DATA as (string[] | IInstrumentsStatic | IInstrumentsDynamic)[] | [];
        let { instrumentsStatic } = state.symbol as { instrumentsStatic: IInstrumentsStatic[] }
        let { instrumentsDynamic } = state.symbol as { instrumentsDynamic: IInstrumentsDynamic[] }
        data = mergeArrayByOnlyKeyArr1(data, instrumentsStatic, 'KEY')
        data = mergeArrayByOnlyKeyArr1(data, instrumentsDynamic, 'KEY')
        return {
            list: list || [],
            data: data || []
        }
    }
    catch (e) {
        return resDefault
    }
}


export const getInstrumentsBySymbolsAction = (params: { config?: object, symbols: string[] }) => {
    try {
        const instruments = dispatch(getInstrumentsBySymbols(params))
        return instruments.unwrap().then(data => {
            return data
        }).catch((error) => {
            console.error("getInstrumentsBySymbolsAction::error", error)
            return []
        })
    }
    catch (e) {
        return []
    }
}

